import React from 'react'
import styled from 'styled-components'

import useIndexPageData from '../../../../cmsHooks/useIndexPageData'
import CMS from '@talus-analytics/library.airtable-cms'

import { Center } from '../../../layout'
import device from '../../../../utilities/device'

import { ActionButton } from 'components/ui'

const ImageContainer = styled.div`
  width: 80%;
  margin-bottom: 40px;
`
const Container = styled.div`
  @media ${device.tablet} {
    &:not(:last-child) {
      margin-bottom: 60px;
    }
  }
`
interface DemoProps {
  type: 'Light' | 'Dark'
}
const Demo = ({ type }: DemoProps): JSX.Element => {
  const data = useIndexPageData()

  return (
    <Container>
      <Center cross>
        <ImageContainer>
          <CMS.Image name={`${type} mode image`} data={data} />
        </ImageContainer>
        <a href={CMS.getText(data, `${type} mode url`)} target="_blank">
          <ActionButton>
            <CMS.Text name={`${type} mode button`} data={data} />
          </ActionButton>
        </a>
      </Center>
    </Container>
  )
}

export default Demo
